import { RHFTextField } from "@app/components";
import { Strings } from "@app/constants";
import { Icon } from "@iconify/react";
import { Button, Stack, useTheme } from "@mui/material";

const SearchBar = ({setSearchTerm , searchTerm}:any) => {
  const theme = useTheme();

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setSearchTerm(e.target.value);
  };
  return (
    <Stack
      sx={{
        width: { xs: "100%", md: "80%" },
        flexDirection: "row",
        alignItems: "center",
        justifyContent: "center",
        mt: { xs: 2, md: 5 },
        border: `1px solid ${theme.palette.grey[400]}`,
        borderRadius: 1,
        px: 2,
      }}
    >
      <Icon
        icon={"material-symbols:search-rounded"}
        style={{
          alignSelf: "center",
          justifySelf: "center",
          color: theme.palette.primary.main,
          fontSize: 32,
        }}
      />
      <RHFTextField
        name={Strings.step.brand.search}
        placeholder={Strings.step.brand.search}
        value={searchTerm}
        onChange={handleChange}
        sx={{
          border: "none",
          backgroundColor: theme.palette.grey[50],
          "& .MuiOutlinedInput-root": {
            "& fieldset": { border: "none" },
            "&:hover fieldset": { border: "none" },
            "&.Mui-focused fieldset": { border: "none" },
            backgroundColor: "transparent",
            boxShadow: "none",
          },
          "& .MuiInputBase-input": {
            padding: "12px 14px",
          },
        }}
      />
      <Button variant="contained" onClick={()=>handleChange}>{Strings.button.search}</Button>
    </Stack>
  );
};

export { SearchBar };
